<div class="bmc-job-settings">
  <div class="bmc-job-settings__top-section">
    <div class="bmc-job-settings__top-section__element">
      <h5 class="bz-font-weight--semibold">{{'GLOBAL.NAME' | translate}}</h5>
      <h5>{{currentJob.name}}</h5>
    </div>

    <div class="bmc-job-settings__top-section__element bmc-job-settings__top-section__element--right">
      <h5 class="bz-font-weight--semibold">{{'JOBS.CREATION_DATE' | translate}}</h5>
      <h5>{{currentJob.creationDate | date:'MM/dd/yyyy h:mm a'}}</h5>
    </div>

  </div>

  <div class="bmc-job-settings__top-section bmc-job-settings__top-section-second">
    <div class="bmc-job-settings__top-section__element">
      <h5 class="bz-font-weight--semibold">{{'JOBS.COLUMN_CASE_NUMBER' | translate}}</h5>
      <h5>{{currentJob.radNumber}}</h5>
    </div>

    <div class="bmc-job-settings__top-section__element bmc-job-settings__top-section__element--right">
      <h5 class="bz-font-weight--semibold">{{'JOBS.COLUMN_CASE_ID' | translate}}</h5>
      <h5>{{currentJob.idCase}}</h5>
    </div>

  </div>

  <div class="bmc-job-settings__middle-section">
    <div class="bmc-job-settings__middle-section__left">
      <h5 class="bz-font-weight--semibold">{{'GLOBAL.DESCRIPTION' | translate}}</h5>
      <h5 class="bmc-job-settings__middle-section__left__text">{{currentJob.description}}</h5>
    </div>
  </div>

  <div class="bmc-job-settings__date-section bz-space--stack-m">
    <h5 class="bz-font-weight--semibold bz-space--stack-s">{{'JOBS.NEXT_RUN_TIME' | translate}}</h5>
    <div class="bmc-job-settings__date-section__run-time">
      <div class="bmc-job-settings__date-section__top bz-space--stack-s">
        <div class="bmc-job-settings__date__input bz-form-item--required bz-form-item bz-space--inline-s" [ngClass]="{'bz-form-item--error' :
          (dpToControl.invalid) && (dpToControl.dirty || dpToControl.touched)}">
          <label class="bz-form-label">{{'GLOBAL.DATE' | translate}}
            <span class="bz-required__icon">*</span>
          </label>
          <div class="bz-input-icon">
            <input class="bz-input bz-input-icon__input bz-space--inline-s"
                    autocomplete="off"
                    placeholder="{{'GLOBAL.SELECT_A_DATE' | translate}}"
                    mask="00/00/0000"
                    id="date-to"
                    #dpTo="bsDatepicker"
                    #dpToControl="ngModel"
                    [(ngModel)]="nextRuntimeDate"
                    name="date-to"
                    [bsConfig]="{ showWeekNumbers: false }"
                    required
                    [disabled]="currentJob.disableEditJob"
                    bsDatepicker>
            <svg class="bz-icn bz-space--inline-s" height="32px" width="32px" (click)="currentJob.disableEditJob || dpTo.show()">
              <use xlink:href="#icon-calendar"></use>
            </svg>
          </div>
          <div class="bz-form-message">
            <span class="bz-form-message__error" *ngIf="dpToControl.invalid && (dpToControl.dirty || dpToControl.touched) && dpToControl.errors.required">
              <svg class="bz-icn bz-space--inline-s" width="16px" height="16px">
                <use xlink:href="#icn-input-error" />
              </svg>
              <label class="bz-form-message__text">
                {{'GLOBAL.REQUIRED_FIELD' | translate}}
              </label>
            </span>
          </div>
        </div>
        <div class="bmc-job-settings__enable">
          <bzg-switch [(ngModel)]='currentJob.enabled' [disabled]="currentJob.disableEditJob === true"></bzg-switch>
          <h5 class="bmc-job-settings__enable__text">{{ 'GLOBAL.ENABLED' | translate}}</h5>
        </div>
      </div>
      <div class="bmc-job-settings__date-section__bottom" >
        <bzg-time-picker class="" name="finished-date" *ngIf="nextRuntimeDateTime.period" [(ngModel)]="nextRuntimeDateTime" [required]="true" [disabled]="currentJob.disableEditJob">
            {{'JOBS.TIME' | translate}}
        </bzg-time-picker>
        <div class="bmc-job-settings__date-section__bottom__button">
          <bzg-button-primary [disabled]="currentJob.disableEditJob" (click)="setJobNow()">{{'JOBS.SET_JOB_NOW' | translate}}</bzg-button-primary>
        </div>
      </div>
    </div>
  </div>

  <div class="" *ngIf="showReset">
    <h5 class="bz-font-weight--semibold">{{'JOBS.RESET_DEVELOP_TITLE' | translate}}</h5>
    <div class="bz-form-message__text">{{'JOBS.RESET_DEVELOP' | translate}} <a class="bmc-job-settings__reset--link" (click)="resetJob()">{{ 'GLOBAL.RESET' | translate}}</a>
    </div>
  </div>
</div>

<div class="bmc-job-settings__buttons bz-flex bz-flex--end">
  <bzg-button-secondary (click)="cancelChanges()">{{ 'GLOBAL.CANCEL' | translate}}</bzg-button-secondary>
  <bzg-button-primary class="bmc-job-settings__buttons--right" (click)="applyChanges()" [disabled]="applyDisabled || currentJob.disableEditJob">{{ 'GLOBAL.APPLY' | translate}}</bzg-button-primary>
</div>
